import { selectOwnerModalActionTypes } from './Constants';

export function toggleSelectOwnerModal(data) {
	return {
		type: selectOwnerModalActionTypes.TOGGLE_SELECT_OWNER_MODAL,
		payload: { data },
	};
}

export function setGroupOwner(groupId, userId, callback) {
	return {
		type: selectOwnerModalActionTypes.SET_GROUP_OWNER,
		payload: { groupId, userId, callback },
	};
}

export function setGroupOwnerSuccess() {
	return {
		type: selectOwnerModalActionTypes.SET_GROUP_OWNER_SUCCESS,
	};
}

export function setGroupOwnerError() {
	return {
		type: selectOwnerModalActionTypes.SET_GROUP_OWNER_ERROR,
	};
}

export function clearState() {
	return {
		type: selectOwnerModalActionTypes.CLEAN_SET_GROUP_OWNER_MODAL_STATE,
	};
}
